// PF 05/05/2020
// This mixin allows a component to receive v-model, which it will watch internally and emit input on any change.
// Simply provide the type and the name for the internal data field
export default ({ type, name, required, validator }) => {
  if (!validateOptions({ type, name, required, validator })) return
  return {
    props: {
      value: getValueConfig({ type, required, validator }),
    },
    data() {
      return {
        [name]: this.value,
      }
    },
    watch: {
      [name]: {
        deep: true,
        handler(newVal) {
          this.$emit('input', newVal)
        },
      },
      value(newVal) {
        this.$set(this, name, newVal)
      },
    },
  }
}

function validateOptions({ type, name, validator, required }) {
  const validType = [String, Number, Boolean, Array, Object, Function, Promise].includes(type)
  if (!validType) console.error('modelMixin: type parameter must be a valid prop type')
  const validName = typeof name === 'string'
  if (!validName) console.error('modelMixin: name paramater must be a string!')
  const validValidator = validValidator ? typeof validValidator === 'function' : true
  if (!validValidator) console.error('modelMixin: validator must be a function!')
  const validRequired = required ? typeof required === 'boolean' : true
  if (!validRequired) console.error('modelMixin: required must be a boolean!')
  return validType && validName && validValidator && validRequired
}

function getValueConfig({ type, required, validator }) {
  if (required || validator) {
    const valueConfig = { type }
    if (required) valueConfig.required = required
    if (validator) valueConfig.validator = validator
    return valueConfig
  } else return type
}
